import { get } from 'lodash';

export const getBrokerageId = (state) => get(state?.login, 'userInfo.getBrokerageDropdownData', null);
